export default "__VITE_ASSET__BQIANCAf__"